var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v(" Для того аби скористатися сервісом потібрно "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openAuthModal.apply(null, arguments)}}},[_vm._v(" Увійти ")]),_vm._v("і верифікувати аккаунт ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }